<div style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item)">
        {{ item }}
      </a>
    </li>
  </ol>
</div>
<div>
  <mat-toolbar class="top_headerbar">
    <h6 class="show-title">Site & Groups</h6>
    <div class="all_action_btns">
      <div class="input-group search_with_filter">
        <div class="input-group-btn search-panel">
          <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">sort_by_alpha</i> Sort</button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>Item 1</button>
            <button mat-menu-item>Item 2</button>
          </mat-menu>
        </div>
        <div class="input-group-btn search-panel">
          <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">filter_list</i> Filter</button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>Item 1</button>
            <button mat-menu-item>Item 2</button>
          </mat-menu>
        </div>
      </div>
      <input type="hidden" name="search_param" value="all" id="search_param">
      <input type="text" class="form-control search_input" name="x" placeholder="Search term...">
      <button class="more-btn-custom" mat-raised-button (click)="addClients()">
          <i class="material-icons icon-layout-custom">add_circle</i><span class="m_l_5 mob_hide">Add New</span>
      </button>
    </div>
  </mat-toolbar>
  <div class="list-box-one site_group_list" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
    <div fxFlex="85%" class="box1">
      <div class="site_group_inner">
        <h4 class="header-layout">Room 123</h4>
        <span class="subheader-layout" style="cursor: pointer;" (click)="showGroupList()"><span class="head"><i
              class="material-icons icon_list_item">group_work</i>Associated groups:</span>12</span>
        <span class="subheader-layout" style="cursor: pointer;" (click)="showAssetsList()"><span class="head"><i
              class="material-icons icon_list_item">settings_input_component</i>No. of assets:</span> 45</span>
        <span class="subheader-layout" style="cursor: pointer;" (click)="showListOfUsers()"><span class="head"><i
              class="material-icons icon_list_item">supervised_user_circle</i>Associated users:</span> 5</span>
        <span class="subheader-layout"><span class="head"><i class="material-icons icon_list_item">build</i>Associated
            devices:</span> 10</span>
      </div>
    </div>
    <div fxFlex="15%" style="margin-top: 25px;" class="box2">
      <div class="align-txt-center" fxFlex="50%">
        <button mat-button (click)="editSiteGroup()"><i class="material-icons icon-orange-color">edit</i></button>
      </div>
      <div class="align-txt-center" fxFlex="50%">
        <button mat-button><i class="material-icons icon-orange-color">delete</i></button>
      </div>
    </div>
  </div>
</div>